import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";

import { ButtonStandard, LoadingSpinner } from "../../components";
import "./SchedulingReport.scss"
import messages from "../../assets/i18n";
import { COMPANIES } from '../../utils/constants';
import havePermissionTo from '../../utils/havePermission';
import { downloadFile } from '../../utils/utilFile';
import { SCHEDULING_REPORT_HEADERS } from '../../utils/constants';

function SchedulingReport(props) {

	const dispatch = useDispatch();
	
	const lang = useSelector(state => state.language.name);	    	
    const permissions = useSelector(state => state.authorization.permissions);
    const titlePage = messages[lang].schedulingReport;

    const isLoadingSchedulingReport = useSelector(state => state.scheduling.isLoadingSchedulingReport);
    const csvReportData = useSelector(state => state.scheduling.csvReportData);

    const [reportFilters, setReportFilters] = useState({
        idEmpresa: COMPANIES.RENNER.ID,
        nomeFornecedor: '',
        nomePortao: '',
        dtEntregaIni: '',
        dtEntregaFim: ''
    });

    const [checkPermission, setCheckPermission] = useState(true);

    const setFilters = (newFilters) => {
        setReportFilters(newFilters)
    };

    const companyOptions = [
        { id: COMPANIES.RENNER.ID, message: COMPANIES.RENNER.NAME },
        { id: COMPANIES.CAMICADO.ID, message: COMPANIES.CAMICADO.NAME },
        { id: COMPANIES.YOUCOM.ID, message: COMPANIES.YOUCOM.NAME },
    ];

    useEffect(() => {	
        if (havePermissionTo("scheduling-report-change-company", permissions)) {
            setCheckPermission(false)
        } else {
            setCheckPermission(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
		if (csvReportData.length > 0) {
			let reportArray = [];
			let fileHeaders = []

			for (let i = 0; i < csvReportData.length; i++) {
				let newItem = []
				for (let j = 0; j < SCHEDULING_REPORT_HEADERS.length; j++) {
					if (i === 0) {
						fileHeaders.push(messages[lang].csvSchedulingReport[SCHEDULING_REPORT_HEADERS[j]])
					}

					let newValue		
					newValue = csvReportData[i][SCHEDULING_REPORT_HEADERS[j]] ? csvReportData[i][SCHEDULING_REPORT_HEADERS[j]] : ''

                    if (typeof newValue === 'string' && newValue.includes(',')) {
                        newValue = newValue.replace(",", "/");
                    }

					newItem.push(newValue)
				}
				reportArray.push(newItem)
			}

			const filename = messages[lang].schedulingReport + `.csv`;	
									
			const textCsv = mountCsvText([fileHeaders, ...reportArray]);
			downloadFile(textCsv, filename);
			dispatch({ type: "SET_CSV_SCHEDULING_REPORT", payload: [] });			
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [csvReportData])

    const mountCsvText = (arrayToText) => {
		const separator = ';';
		return arrayToText.reduce((csvText, currentRow) => {

			const rowText = currentRow.reduce((csvRow, currentColumn) => {
				return csvRow ? `${csvRow}${separator}${currentColumn}` : currentColumn
			}, '');

			return csvText ? `${csvText}\n${rowText}` : rowText
		}, '');
	}

	const getReport = () => {        
		dispatch({
			type: 'GET_SCHEDULING_REPORT',
            payload: {
                permissions: permissions,
                filters: reportFilters,
                checkPermission: checkPermission
            }
		})
	}

    const getCSVReport = () => {        
		dispatch({
			type: 'GET_CSV_SCHEDULING_REPORT',
            payload: {
                permissions: permissions,
                filters: reportFilters,
                checkPermission: checkPermission
            }
		})
	}

	return (
		<div className="scheduling-report-page">
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <Form className="px-3">
                    <Row>
                        {
                            havePermissionTo("scheduling-report-change-company", permissions) 
                            ?
                            <Form.Group as={Col} className="mt-1">
                                <Form.Label className="text-2">{messages[lang].company}</Form.Label>

                                <Form.Control
                                    as="select"
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={reportFilters.idEmpresa || ''}
                                    disabled={false}
                                    onChange={event => setFilters(
                                        { ...reportFilters, idEmpresa: event.target.value },
                                        )}
                                >
                                    {
                                        companyOptions.map(value => (
                                            <option key={value.message} value={value.id}>{value.message}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Form.Group>
                            :
                            null

                        }
                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].provider}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].provider}
                                    type="text"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                    { ...reportFilters, nomeFornecedor: event.target.value },
                                    )}
                                />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].gate}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].gate}
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                    { ...reportFilters, nomePortao: event.target.value },
                                    )}
                                />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].dtEntregaInicial}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].dtEntregaInicial}
                                    type="date"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                        { ...reportFilters, dtEntregaIni: event.target.value },
                                    )}
                                />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messages[lang].dtEntregaFinal}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    placeholder={messages[lang].dtEntregaFinal}
                                    type="date"
                                    defaultValue={''}
                                    onChange={event => setFilters(
                                        { ...reportFilters, dtEntregaFim: event.target.value },
                                    )}
                                />
                        </Form.Group>
                    </Row>
                </Form>
            </Container>

            <Container className="px-4 d-flex justify-content-end">
                <ButtonStandard
					text={messages[lang].getReport}
					textClass="text-1"
					className="dropdown btn-outline-success btn-sm btn-standard px-2 mr-2"
					disabled={isLoadingSchedulingReport}
					dropdownActions={
						[
							{
								label: 'CSV',
                                action: () => getCSVReport()
							},
							{
								label: 'PDF',
								action: () => getReport()
							}
						]
                    }
                />

{/* 
				<ButtonStandard
					text={messages[lang].getReport}
                    disabled={false}
					textClass="text-2"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getReport()}/> */}
			</Container>   

            {
                isLoadingSchedulingReport
                ?
                <div className="loader">
                    <LoadingSpinner />
                </div>     
                :
                null
            }
   
		</div>
	)
}

export default withRouter(SchedulingReport);